import script from "./ModelView.vue?vue&type=script&lang=ts&setup=true"
export * from "./ModelView.vue?vue&type=script&lang=ts&setup=true"

import "./ModelView.vue?vue&type=style&index=0&id=7d64ab4a&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d64ab4a"]])

export default __exports__